import * as React from 'react';
import Text, { Props as TextProps } from '../Text/Text';

export interface Props extends TextProps {}

/** Provides specific styling for an inline input label */
const InputInlineHelp: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Text config="8" margin="x2" textColor="gray-6" { ...props } />
  );
};

export default InputInlineHelp;
